import { render } from "./AjaxSelectField.vue?vue&type=template&id=5db78960"
import script from "./AjaxSelectField.vue?vue&type=script&lang=js"
export * from "./AjaxSelectField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AjaxSelectField.vue"]])

export default __exports__